<dx-popup
  [visible]="dialog.visible()"
  (visibleChange)="onPopupVisibleChange($event)"
  [showTitle]="true"
  title="Something went wrong"
  [width]="420"
  [height]="'auto'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [shading]="true">
  <div class="unexpected-error-dialog__body">
    <p>Crystal couldn't complete that action. Nothing was saved.</p>
    <p>Please contact IT support at <strong>support&#64;calysta.eu</strong>, or message any IT member on Teams.</p>

    @if (dialog.reference()) {
      <p>Please include this reference:</p>
      <div class="unexpected-error-dialog__reference">
        <code>{{ dialog.reference() }}</code>
        <dx-button icon="copy" hint="Copy reference" stylingMode="text" (onClick)="copyReference()" />
      </div>
    }

    <div class="unexpected-error-dialog__actions">
      <dx-button text="Close" type="default" (onClick)="dialog.hide()" />
    </div>
  </div>
</dx-popup>
